// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3zVjQ3hthECjjCRuvqU-7H"};